import axios from "axios"
import env from "src/env"

const {
  REACT_APP_REFRESH_TOKEN_URL,
  REACT_APP_GET_TOKENS_URL,
  REACT_APP_CLIENT_ID,
} = env

// Спека https://next.stoplight.io/infotech-group/accounts-admin/version%2F1.0/main.hub.yml?view=%2Foauth-api%2Foauth%2Fgeneratetoken

export const refreshByCodeRequest = (code, redirectUrl) =>
  axios({
    headers: {},
    method: `post`,
    url: REACT_APP_GET_TOKENS_URL,
    data: {
      client_id: REACT_APP_CLIENT_ID,
      code,
      redirect_uri: redirectUrl,
    },
  })

export const refreshRequest = refreshToken =>
  axios({
    headers: {},
    method: `post`,
    url: REACT_APP_REFRESH_TOKEN_URL,
    data: {
      refresh_token: refreshToken,
    },
  })